import React, { useContext, useState } from 'react';

import { FilterContext } from '../../../../Context/FilterContext';
import SimpleLink from '../../../../Form/SimpleLink/SimpleLink';
import InfoComponent from '../../../../InfoComponent/InfoComponent';
import LoginOverlayButton from '../../../../Login/LoginOverlayButton';
import Modal from '../../../../Modal/Modal';
import { overlayHash } from '../../../../OnlineAnalysis/OnlineAnalysis';
import StandardFilter from '../../StandardFilter/StandardFilter';

import './../Filter.scss';

interface Props {
    visible: boolean;
    toggleVisibility: () => void;
}

declare global {
    interface Window {
        __GGOnlineAnalysisInfoText: string;
        __GGPhoneAnalysisInfoText: string;
        __GGConsultantAnalysisInfoText: string;
        __GGOnlineAnalysisIntroText: string;
        __GGPhoneAnalysisIntroText: string;
        __GGConsultantAnalysisIntroText: string;
        Carbon: any;
        location: Location;
    }
}

const LoggedOutFilterModal: React.FunctionComponent<Props> = (props) => {
    const [resetTimestamp, updateResetTimestamp] = useState(0);
    const { updateStandardFilterValues } = useContext(FilterContext);

    const resetStandardFilter = () => {
        updateResetTimestamp(new Date().getTime() / 1000);
        updateStandardFilterValues(null);
    };

    return (
        <div className="product-filter">
            <Modal visible={props.visible} toggleVisibility={props.toggleVisibility} centerHorizontally={true}>
                <div className="filter-overlay">
                    <div className="filter__logged-out-header">
                        <div className="filter__login">
                            <h3>Anmeldung</h3>
                            <p>Bitte melden Sie sich an.</p>
                            <LoginOverlayButton primary={true} onClick={props.toggleVisibility} />
                        </div>

                        <div className="filter-overlay__controls filter-overlay-controls">
                            <button
                                onClick={resetStandardFilter}
                                type="button"
                                className="filter-overlay-controls__button"
                            >
                                <svg className="icon">
                                    <use xlinkHref="#icon-undo" />
                                </svg>
                                <span>Filter zurücksetzen</span>
                            </button>
                        </div>
                    </div>

                    <StandardFilter toggleVisibility={props.toggleVisibility} resetTimestamp={resetTimestamp} />

                    <div className="filter__logged-out-options">
                        <div className="filter__analysis">
                            <div>
                                <h4>
                                    Online-Hautbild-Analyse
                                    <InfoComponent text={window.__GGOnlineAnalysisInfoText} />
                                </h4>

                                <p>{window.__GGOnlineAnalysisIntroText}</p>
                                <button
                                    className="simple-link"
                                    onClick={() => {
                                        props.toggleVisibility();
                                        window.Carbon('dialogues')['carbon-dialog__login-default'].show();
                                        window.location.hash = overlayHash;
                                    }}
                                >
                                    <svg className="icon icon--arrow-right">
                                        <use xlinkHref="#icon-arrow-right" />
                                    </svg>
                                    <span>Online-Hautbild-Analyse durchführen</span>
                                </button>
                            </div>
                        </div>
                        <div className="filter__analysis">
                            <div>
                                <h4>
                                    Telefonische Fachberater-Hautbild-Analyse
                                    <InfoComponent text={window.__GGPhoneAnalysisInfoText} />
                                </h4>

                                <p>{window.__GGPhoneAnalysisIntroText}</p>
                                <SimpleLink
                                    text="Telefonische Fachberater-Hautbild-Analyse anfragen"
                                    link={window.__GGConsultantSearchUri}
                                    arrowRight={false}
                                />
                            </div>
                        </div>
                        <div className="filter__analysis">
                            <div>
                                <h4>
                                    Fachberater Hautbild-Analyse im Einzeltermin
                                    <InfoComponent text={window.__GGConsultantAnalysisInfoText} />
                                </h4>
                                <p>{window.__GGConsultantAnalysisIntroText}</p>
                                <SimpleLink
                                    text="zur Beratersuche"
                                    link={window.__GGConsultantSearchUri}
                                    arrowRight={false}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default LoggedOutFilterModal;
